export interface Change {
  title: string;
  description: string;
  note?: string;
}

export const changes: Change[] = [
  {
    title: 'More of the app is translated',
    description:
      'Sidebar and tool labels now come from language files, so translations show up correctly.',
    note: 'Makes the interface friendlier in other languages.',
  },
  {
    title: 'Sharper flags in the language menu',
    description:
      'Language options use a new flag component for crisp, well‑aligned country flags.',
    note: 'Easier to spot your language at a glance.',
  },
  {
    title: 'Fermentation calculator handles multiple scales',
    description:
      'The calculator now works with different measurement scales, letting you brew with your preferred units.',
    note: 'Flexible for any brewing style.',
  },
];
